export default "__VITE_ASSET__rh9rjhD5__"